import React from 'react';

import MenuList from '@material-ui/core/MenuList';
import GrowPopper from 'cityads-v3/components/GrowPopper/GrowPopper';

export default function MenuPopper({ children, ...rest }) {
  return (
    <GrowPopper {...rest}>
      <MenuList>
        {children}
      </MenuList>
    </GrowPopper>
  );
}
